// Top-of-page progress bar for Turbo Frame link navigations, which Turbo's built-in bar
// ignores (it only covers Drive visits and form submissions). Returns { start, complete } so
// a caller can drive the same bar manually for non-Turbo loads (e.g. a plain fetch).
export default function installTurboFrameProgressBar(frameId) {
  let bar;
  let startTime;
  let timer;
  let active = false;

  const getBar = () => {
    if (!bar) {
      bar = document.createElement('div');
      bar.dataset.testid = 'turbo-frame-progress-bar';
      bar.style.cssText = `
        position:fixed;
        top:0;
        left:0;
        width:100%;
        height:3px;
        background:#0076ff;
        z-index:9999;
        transform:scaleX(0);
        transform-origin:left;
        transition:transform 150ms ease-out;
      `;
      document.body.appendChild(bar);
    }

    return bar;
  };

  const update = () => {
    if (!active) {
      return;
    }
    const progress = Math.min(0.9, 1 - Math.exp(-(Date.now() - startTime) / 1000));

    getBar().style.transform = `scaleX(${progress})`;
    if (progress < 0.9) {
      timer = requestAnimationFrame(update);
    }
  };

  const start = () => {
    if (active) {
      return;
    }
    active = true;
    startTime = Date.now();
    const element = getBar();

    element.style.transform = 'scaleX(0)';
    element.style.opacity = '1';
    timer = requestAnimationFrame(update);
  };

  const complete = () => {
    if (!active) {
      return;
    }
    active = false;
    if (timer) {
      cancelAnimationFrame(timer);
    }
    const element = getBar();

    element.style.transform = 'scaleX(1)';
    setTimeout(() => {
      element.style.opacity = '0';
      setTimeout(() => (element.style.transform = 'scaleX(0)'), 150);
    }, 150);
  };

  document.addEventListener('turbo:before-fetch-request', (e) => {
    if (e.target.closest?.(`turbo-frame[id="${frameId}"]`)) {
      start();
    }
  });

  ['turbo:frame-render', 'turbo:frame-load'].forEach((event) => {
    document.addEventListener(event, (e) => {
      if (e.target.id === frameId) {
        complete();
      }
    });
  });

  document.addEventListener('turbo:submit-end', (e) => {
    if (e.target.dataset?.turboFrame === frameId) {
      complete();
    }
  });

  return { start, complete };
}
